import { IFormGenConfig } from "~/widgets/FormGen/model/schema";
import * as yup from "yup";
import { TFunction } from "i18next";
import { IAppealSendCommentParams } from "~/entity/Appeals/model/schema";

interface IGetFormConfigProps {
  translateFunc: TFunction;
}

export const getFormConfigToCommentAppeal = ({
  translateFunc,
}: IGetFormConfigProps): IFormGenConfig<IAppealSendCommentParams> => {
  return {
    schema: yup.object().shape({
      comment: yup
        .string()
        .trim()
        .required(translateFunc("validation.required")),
    }),
    layout: { columns: 1, gap: 10 },
    fields: [
      {
        type: "textarea",
        name: "comment",
        label: "Введите комментарий",
        span: 1,
        props: {
          fullWidth: true,
        },
      },
    ],
  };
};
